import $ from 'jquery'

export function openVideoModal(modal, activeClass) {
  modal.classList.add(activeClass)
  document.body.classList.add('u-no-scroll')
  const modalClose = modal.querySelector('.c-modal__close')
  modal.classList.add(activeClass)
  modalClose.addEventListener('click', (e) => {
    e.preventDefault()
    modal.classList.remove(activeClass)
    document.body.classList.remove('u-no-scroll')
  })
}

export function openApplyModal(modal, activeClass) {
  modal.classList.add(activeClass)
  document.body.classList.add('u-no-scroll')
  const modalClose = modal.querySelector('.c-modal__close')
  modal.classList.add(activeClass)
  anime({
    targets: modal,
    delay: 150,
    translateY: [2000, 0],
    easing: 'easeInOutQuart',
    duration: 500,
  })


  modalClose.addEventListener('click', (e) => {
    e.preventDefault()
    anime({
      targets: modal,
      translateY: [0, 2000],
      easing: 'easeInOutQuart',
      duration: 500,
      complete() {
        modal.classList.remove(activeClass)
        document.body.classList.remove('u-no-scroll')
      },
    })
  })
}

export function openMenuModal(modal, activeClass) {
  document.body.classList.add('u-no-scroll')
  const modalClose = modal.querySelector('.c-modal__menu-close')
  modal.classList.add(activeClass)

  anime({
    targets: modal,
    translateX: ['100%', '0'],
    easing: 'easeOutQuad',
    duration: 300,
  })
  const animationTarget = modal.querySelector('.c-nav__links--menu')
  const navLinks = [...modal.querySelectorAll('.c-nav__link__menu')]
  navLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      anime({
        targets: modal,
        translateX: ['0', '100%'],
        easing: 'easeOutQuad',
        duration: 300,
        complete() {
          modal.classList.remove(activeClass)
        },
      })
      document.body.classList.remove('u-no-scroll')
    })
  })

  modalClose.addEventListener('click', (e) => {
    e.preventDefault()
    anime({
      targets: modal,
      translateX: ['0', '100%'],
      easing: 'easeOutQuad',
      duration: 300,
      complete() {
        modal.classList.remove(activeClass)
      },
    })
    document.body.classList.remove('u-no-scroll')
  })
}

export function openFundingModal(modal, activeClass) {
  modal.classList.add(activeClass)
  const modalClose = modal.querySelector('.c-modal__close')
  modal.classList.add(activeClass)
  document.body.classList.add('u-no-scroll')

  modalClose.addEventListener('click', (e) => {
    e.preventDefault()
    modal.classList.remove(activeClass)
    document.body.classList.remove('u-no-scroll')
  })
}
